import { useState } from 'react';
import { Box } from '@mui/material';
import { AgingBucket, IAgingReceivables } from 'src/types';
import AgingBucketCards from './aging-bucket-cards';
import ClientAgingTable from './client-aging-table';

type Props = {
  data: IAgingReceivables;
};

export default function ReceivablesSection({ data }: Props) {
  const [activeBucket, setActiveBucket] = useState<AgingBucket | null>(null);

  const handleBucketClick = (bucket: AgingBucket) => {
    setActiveBucket(activeBucket === bucket ? null : bucket);
  };

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <AgingBucketCards
        buckets={data.buckets}
        activeBucket={activeBucket}
        onBucketClick={handleBucketClick}
      />
      <ClientAgingTable clients={data.clients} activeBucket={activeBucket} />
    </Box>
  );
}
